// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1ZglB","layout":"styles_layout__6B-fO"};